module.exports = __webpack_public_path__ + "officialStatic/img/choose.d0313a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/choose.png
// module id = fqPT
// module chunks = 0